import { useSelector } from "react-redux"
import { Navigate } from "react-router-dom"

import Column, { PaddedContentColumn } from "../../../common/components/Column"
import PageTopSection from "../../../common/components/PageTopSection"
import { isConcierge } from "../../users/accountRole"
import {
  selectProfile,
  selectProfileLoaded,
  selectSubscription,
} from "../../users/reducer"
import { getLandingPath } from "../components/sidebarLinkConfig"
import InboxTab from "../settings/InboxTab"

/**
 * Email / SMS / voicemail inbox (moved out of Settings). The inbox APIs are
 * concierge-only, so everyone else is sent to their landing page.
 */
export default function Messages() {
  const profile = useSelector(selectProfile)
  const profileLoaded = useSelector(selectProfileLoaded)
  const subscription = useSelector(selectSubscription)

  if (profileLoaded && !isConcierge(profile)) {
    return <Navigate to={getLandingPath(profile, subscription)} replace />
  }

  return (
    <Column>
      <PageTopSection title="Messages" />
      <PaddedContentColumn pb={0} sx={{ overflow: "hidden", minHeight: 0 }}>
        {profileLoaded ? <InboxTab /> : null}
      </PaddedContentColumn>
    </Column>
  )
}
